import { styled } from "@mui/material/styles"
import { useMemo } from "react"

import ButtonDialog from "#common/Dialog/ButtonsDialog"
import { Stack } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
		overflowY: "auto",
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},
	"& .MuiPaper-root": {
		borderRadius: theme.shape.borderRadius * 5, // más redondeado
		boxShadow: theme.shadows[5], // sombra más notoria
		backgroundColor: theme.palette.background.paper, // puedes cambiar color de fondo
	},
}))

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
	padding: "2vw !important",
	// Estilos personalizados para el scrollbar
	"&::-webkit-scrollbar": {
		width: "4px",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: theme.palette.primary.main,
		borderRadius: "6px",
	},
	"&::-webkit-scrollbar-track": {
		backgroundColor: theme.palette.background.default,
		borderRadius: "10px",
	},
}))

export function MasterDialog({
	title,
	open,
	setOpen,
	children,
	buttons,
	propsChildren,
	propsTitle,
	maxWidth = "xs",
	closeDialog = () => {},
	...props
}) {
	const componentTitle = useMemo(() => {
		if (!title) return null
		return (
			<DialogTitle
				id="Dialog-Form"
				textAlign="center"
				textTransform={"capitalize"}
				{...propsTitle}
			>
				{title}
			</DialogTitle>
		)
	}, [propsTitle, title])

	const componentContent = useMemo(() => {
		if (!children) return null
		return (
			<CustomDialogContent dividers {...propsChildren}>
				{children}
			</CustomDialogContent>
		)
	}, [children, propsChildren])

	const componentButtons = useMemo(() => {
		if (!buttons) return null

		return (
			<DialogActions sx={{ alignContent: "center", justifyContent: "center" }}>
				<Stack direction="row" spacing={3}>
					{buttons.map((button) => (
						<ButtonDialog key={`buttonDialog${button.label}`} {...button} />
					))}
				</Stack>
			</DialogActions>
		)
	}, [buttons])

	return (
		<BootstrapDialog
			fullWidth={true}
			maxWidth={maxWidth}
			// maxWidth=""
			open={open}
			onClose={() => {
				setOpen(false)
				closeDialog()
			}}
			{...props}
		>
			{componentTitle}
			{componentContent}
			{componentButtons}
		</BootstrapDialog>
	)
}
